// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".actions[data-v-4e0ecc12]{width:3rem}.is-disabled[data-v-4e0ecc12]{color:#d3d3d3;cursor:not-allowed;pointer-events:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
